import { Box, Text } from '@mantine/core'
import {
	TextFixRefusal,
	TextFixResult,
	WORD_FILE_FULL_CHANGE_ADVICE,
	WORD_FILE_REPLACE_NOTICE,
	describeTextFixRefusal,
	describeTextFixResult,
} from 'src/utils/chapterWordFile'

// UD-614: what replacing a chapter's Word file in the CMS does, in two short lines, and what
// is shown when the file was not replaced or was replaced in part. The CMS has this one way to
// replace a file; it never starts the paid redo of translations and audio.

const Advice = () => (
	<Text size="xs" mt={4} color="dimmed">
		{WORD_FILE_FULL_CHANGE_ADVICE}
	</Text>
)

export function WordFileReplaceNotice() {
	return (
		<Box
			data-testid="word-file-replace-notice"
			sx={{
				border: '1px solid #f2d98c',
				background: '#fffbea',
				borderRadius: 10,
				padding: '10px 12px',
			}}
		>
			<Text size="sm">{WORD_FILE_REPLACE_NOTICE}</Text>
			<Advice />
		</Box>
	)
}

export function WordFileRefusalAlert({ refusal }: { refusal: TextFixRefusal }) {
	return (
		<Box
			role="alert"
			sx={{
				border: '1px solid #f3b4a8',
				background: '#fff4f1',
				borderRadius: 10,
				padding: '10px 12px',
			}}
		>
			<Text size="sm" weight={600} sx={{ color: '#b42318' }}>
				Not replaced. {describeTextFixRefusal(refusal)}
			</Text>
			<Advice />
		</Box>
	)
}

// Shown when the file was replaced but something it changes is not in the English text
export function WordFilePartialResult({ result }: { result: TextFixResult }) {
	return (
		<Box
			role="alert"
			sx={{
				border: '1px solid #f2d98c',
				background: '#fffbea',
				borderRadius: 10,
				padding: '10px 12px',
			}}
		>
			<Text size="sm" weight={600} sx={{ color: '#8a5a00' }}>
				{describeTextFixResult(result)}
			</Text>
			<Advice />
		</Box>
	)
}
